export const SET_WIDTH = "SET_WIDTH"